import React from 'react';
import { Carousel } from 'antd';

const AppCarousel = ({ data }) => {
  const renderData = () => data.map((d, idx) => <div key={idx}>{d}</div>);
  return (
    <Carousel dotPosition="top" autoplay>
      {renderData()}
    </Carousel>
  );
};

export default AppCarousel;
